module.exports = __webpack_public_path__ + "static/media/Background1.05c68bb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Backgrounds/Background1.png
// module id = 252
// module chunks = 0